module.exports = __webpack_public_path__ + "front-end-tools.3OiyF8-W.svg";